import { useNavigate } from "react-router-dom";

const PricingCard = ({ plan }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-full p-8 bg-white border border-gray-100 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
      <h3 className="text-2xl font-bold text-gray-800">{plan.name}</h3>
      <p className="text-gray-500 mt-2 text-sm leading-relaxed">{plan.description}</p>
      
      <div className="my-6">
        <span className="text-5xl font-extrabold text-green-900">
          {plan.currencySymbol}{plan.price}
        </span>
        <span className="text-gray-400 ml-2 font-medium">/{plan.days || 'month'}</span>
      </div>

      <ul className="space-y-4 mb-8">
        {plan.features.map((feature, i) => (
          <li key={i} className="flex items-start text-gray-600 text-sm">
            <span className="mr-2 text-green-600">✓</span>
            {feature}
          </li>
        ))}
      </ul>

      <button 
        onClick={() => navigate("/lead-form")}
        className="mt-auto w-full py-4 bg-green-900 hover:bg-green-800 text-white font-semibold rounded-xl transition-colors"
      >
        Get Started
      </button>
    </div>
  );
};

export default PricingCard;